import Box from "@mui/material/Box";
import PropTypes from "prop-types";

/** Full story image after solve — no grid, tiles, or die lines. */
export default function PuzzleSolvedOriginalImage({ imageUrl, alt = "", sx = {} }) {
    if (!imageUrl) return null;
    return (
        <Box
            component="img"
            src={imageUrl}
            alt={alt}
            referrerPolicy="no-referrer"
            sx={{
                width: "100%",
                height: "100%",
                display: "block",
                objectFit: "contain",
                borderRadius: 1,
                ...sx,
            }}
        />
    );
}

PuzzleSolvedOriginalImage.propTypes = {
    imageUrl: PropTypes.string.isRequired,
    alt: PropTypes.string,
    sx: PropTypes.object,
};
